import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FadvBaseComponent, Forward, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/box/box';

class FadvBoxComponent extends FadvBaseComponent {
    constructor() {
        super(...arguments);
        this.p = null;
        this.pt = null;
        this.pr = null;
        this.pb = null;
        this.pl = null;
        this.ph = null;
        this.pv = null;
        this.m = null;
        this.mt = null;
        this.mr = null;
        this.mb = null;
        this.ml = null;
        this.mh = null;
        this.mv = null;
        this.invert = false;
        this.display = 'block';
    }
}
FadvBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBoxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
FadvBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvBoxComponent, selector: "fadv-box", inputs: { p: "p", pt: "pt", pr: "pr", pb: "pb", pl: "pl", ph: "ph", pv: "pv", m: "m", mt: "mt", mr: "mr", mb: "mb", ml: "ml", mh: "mh", mv: "mv", invert: "invert", display: "display" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvBoxComponent.prototype, "p", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "pt", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "pr", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "pb", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "pl", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "ph", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "pv", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "m", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "mt", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "mr", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "mb", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "ml", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "mh", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "mv", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "invert", void 0);
__decorate([
    Forward()
], FadvBoxComponent.prototype, "display", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBoxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-box',
                    template: '<ng-content></ng-content>',
                }]
        }], propDecorators: { p: [{
                type: Input
            }], pt: [{
                type: Input
            }], pr: [{
                type: Input
            }], pb: [{
                type: Input
            }], pl: [{
                type: Input
            }], ph: [{
                type: Input
            }], pv: [{
                type: Input
            }], m: [{
                type: Input
            }], mt: [{
                type: Input
            }], mr: [{
                type: Input
            }], mb: [{
                type: Input
            }], ml: [{
                type: Input
            }], mh: [{
                type: Input
            }], mv: [{
                type: Input
            }], invert: [{
                type: Input
            }], display: [{
                type: Input
            }] } });

class FadvBoxModule {
}
FadvBoxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBoxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvBoxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvBoxModule, declarations: [FadvBoxComponent], imports: [FadvCommonModule], exports: [FadvBoxComponent] });
FadvBoxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBoxModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvBoxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvBoxComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvBoxComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvBoxComponent, FadvBoxModule };
